<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>

          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px;border-radius: 10px;">
      <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
        <div class="row">
          <div class="col-sm-12">
            <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
              <h6 class="head-title margin-top-8"><span>Upload Revised IQVIA</span></h6>
            </div>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">

            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile" name="myfile" (change)="onFileSelect($event)"
                #UploadFileInput>
              <label class="custom-file-label" for="customFile">{{fileInputLabel || 'Choose File'}}</label>
            </div>

          </div>
          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button class="btn btn-primary excel-upload" type="submit">Upload</button>
          </div>
          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button class="btn btn-primary excel-upload" type="submit">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>